import type { HTMLAttributes } from "vue"
import { defineComponent, inferProps, renderSlot, type ReactiveComponent } from "vue-utils"

interface Props {
	buttons?: number
}

const FormButtons: ReactiveComponent<Props, HTMLAttributes> = (props, { slots, attrs }) => {
	return () => {
		const slot = renderSlot(slots)
		const children = props.buttons ?? (slot.children?.length as number) ?? 0

		return (
			<div class="flex items-center justify-end">
				<div class="inline-grid spacing-2" style={{ gridTemplateColumns: `repeat(${children}, 1fr)` }} {...attrs}>
					{slot}
				</div>
			</div>
		)
	}
}

export default defineComponent(FormButtons, inferProps<Props>())
